<template>
  <div class="_purchase-container">
    <p><span></span>点击帮用户充值VIP<span></span></p>
    <ul>
      <li
        @click.stop="clickSelect(commodity.name)"
        v-for="commodity in commodities"
        :key="commodity.name"
      >
        <p>{{ commodity.name }}</p>
        <p>
          <span>¥</span><span>{{ commodity.amount }}</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { getVipCombos } from "@/api/vip";

export default {
  name: "Sell",
  data() {
    return {
      commodities: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.commodities = await getVipCombos();
    },
    clickSelect(name) {
      this.$emit("click-combo", name);
    }
  }
};
</script>

<style lang="scss" scoped>
._purchase-container {
  padding: 10px 0;
  > p:first-child {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(240, 112, 5, 1);
    line-height: 20px;
    > span {
      margin: 0 8px;
      display: inline-block;
      border-radius: 50%;
      width: 5px;
      height: 5px;
      background: rgb(216, 216, 216);
    }
  }
  > ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    > li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 48px;
      border-radius: 6px;
      > p {
        color: rgba(255, 255, 255, 1);
      }
      > p:nth-child(1) {
        font-size: 14px;
        line-height: 14px;
      }
      > p:nth-child(2) {
        margin-top: 7px;
        line-height: 14px;
        > span:nth-child(1) {
          font-size: 12px;
          font-weight: 600;
        }
        > span:nth-child(2) {
          font-size: 18px;
          font-weight: 600;
        }
      }
    }
    > li:nth-child(-n + 3) {
      background: linear-gradient(
        225deg,
        rgba(221, 171, 95, 1) 0%,
        rgba(234, 195, 122, 1) 100%
      );
    }
    > li:nth-child(n + 4) {
      background: linear-gradient(
        219deg,
        rgba(209, 99, 255, 1) 0%,
        rgba(168, 77, 255, 1) 100%
      );
    }
  }
}
</style>
